(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.add('always-fixed');
      }

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
	class ProductModal extends ModalDialog {
		constructor() {
			super();

			this.mediaItems = Array.from(
				this.querySelectorAll('.product-media-modal__content > [data-media-id]')
			);
			this.content = this.querySelector('.product-media-modal__content');
			this.currentCounter = this.querySelector('[data-media-modal-current]');
			this.totalCounter = this.querySelector('[data-media-modal-total]');
			this.previousButton = this.querySelector('[data-media-modal-prev]');
			this.nextButton = this.querySelector('[data-media-modal-next]');
			this.activeIndex = 0;
			this.pointerStartX = null;

			this.previousButton?.addEventListener('click', () => this.navigate(-1));
			this.nextButton?.addEventListener('click', () => this.navigate(1));
			this.addEventListener('keydown', this.handleKeydown.bind(this));
			this.content?.addEventListener('pointerdown', (event) => {
				this.pointerStartX = event.clientX;
			});
			this.content?.addEventListener('pointerup', (event) => {
				if (this.pointerStartX === null || this.classList.contains('is-zoomed')) return;

				const distance = event.clientX - this.pointerStartX;
				this.pointerStartX = null;

				if (Math.abs(distance) < 50) return;
				this.navigate(distance > 0 ? -1 : 1);
			});
			this.content?.addEventListener('click', (event) => {
				if (event.target.matches('img.active')) {
					this.setZoomed(!this.classList.contains('is-zoomed'));
				}
			});
		}

		hide() {
			this.setZoomed(false);
			super.hide();
			window.pauseAllMedia();
		}

		show(opener) {
			super.show(opener);
			this.showActiveMedia();
		}

		showActiveMedia() {
			const mediaId = this.openedBy?.getAttribute('data-media-id');
			const mediaIndex = this.mediaItems.findIndex(
				(item) => item.getAttribute('data-media-id') === mediaId
			);

			this.setActiveMedia(mediaIndex >= 0 ? mediaIndex : 0);
		}

		setActiveMedia(index) {
			if (!this.mediaItems.length) return;

			this.activeIndex = (index + this.mediaItems.length) % this.mediaItems.length;
			this.setZoomed(false);
			window.pauseAllMedia();

			this.mediaItems.forEach((item, itemIndex) => {
				const isActive = itemIndex === this.activeIndex;
				item.classList.toggle('active', isActive);
				item.setAttribute('aria-hidden', String(!isActive));
			});

			const activeMedia = this.mediaItems[this.activeIndex];

			if (
				activeMedia?.nodeName === 'DEFERRED-MEDIA' &&
				activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
			) {
				activeMedia.loadContent();
			}

			if (this.currentCounter) {
				this.currentCounter.textContent = this.activeIndex + 1;
			}

			if (this.totalCounter) {
				this.totalCounter.textContent = this.mediaItems.length;
			}

			const hasMultipleItems = this.mediaItems.length > 1;
			if (this.previousButton) this.previousButton.disabled = !hasMultipleItems;
			if (this.nextButton) this.nextButton.disabled = !hasMultipleItems;
		}

		navigate(direction) {
			this.setActiveMedia(this.activeIndex + direction);
		}

		setZoomed(isZoomed) {
			this.classList.toggle('is-zoomed', isZoomed);

			const activeMedia = this.mediaItems[this.activeIndex];
			if (isZoomed && activeMedia?.matches('img[data-zoom-src]')) {
				activeMedia.removeAttribute('srcset');
				activeMedia.src = activeMedia.dataset.zoomSrc;
			}

			if (!isZoomed && this.content) {
				this.content.scrollTo({ top: 0, left: 0 });
			}
		}

		handleKeydown(event) {
			if (!this.hasAttribute('open')) return;

			if (event.key === 'ArrowLeft') {
				event.preventDefault();
				this.navigate(-1);
			}

			if (event.key === 'ArrowRight') {
				event.preventDefault();
				this.navigate(1);
			}
		}
	}

	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations--single');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch(e => {
						console.error(e);
					});
			}

			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}

	customElements.define('product-modal', ProductModal);
	customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);
	

  } catch(e) { console.error(e); }
})();
})();
